import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  process.env.TWENTY_API_URL,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {

  /**
   * Retreives a user's session.
   *
   * @returns {AxiosPromise}
   */
  getSession() {
    return conduit.get('/session', [], []);
  },

  /**
   * @returns {AxiosPromise}
   */
  getAvailableBrands() {
    return conduit.get('booking/sales-statistics/brands');
  },

  /**
   * @param filters
   * @returns {AxiosPromise}
   */
  getBookingSalesStatistics(filters) {
    return conduit.post(
      'booking/sales-statistics',
      {
        brandIds: filters.brandIds,
        from: filters.from,
        to: filters.to,
      },
    );
  },

  /**
   * @param areaId
   * @returns {AxiosPromise}
   */
  getArea(areaId) {
    return conduit.get(`area/${areaId}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/twenty-service.js